// Static cache of most valuable cards
// Last updated: 2024-02-05
export const valuableCards = [
  {
    "id": "base1-4",
    "name": "Charizard",
    "number": "4",
    "images": {
      "small": "https://images.pokemontcg.io/base1/4.png",
      "large": "https://images.pokemontcg.io/base1/4_hires.png"
    },
    "set": {
      "id": "base1",
      "name": "Base",
      "series": "Base",
      "printedTotal": 102,
      "total": 102,
      "releaseDate": "1999/01/09"
    },
    "cardmarket": {
      "prices": {
        "averageSellPrice": 399.99,
        "lowPrice": 299.99,
        "trendPrice": 449.99
      }
    }
  },
  {
    "id": "base1-2",
    "name": "Blastoise",
    "number": "2",
    "images": {
      "small": "https://images.pokemontcg.io/base1/2.png",
      "large": "https://images.pokemontcg.io/base1/2_hires.png"
    },
    "set": {
      "id": "base1",
      "name": "Base",
      "series": "Base",
      "printedTotal": 102,
      "total": 102,
      "releaseDate": "1999/01/09"
    },
    "cardmarket": {
      "prices": {
        "averageSellPrice": 199.99,
        "lowPrice": 149.99,
        "trendPrice": 249.99
      }
    }
  },
  {
    "id": "base1-1",
    "name": "Alakazam",
    "number": "1",
    "images": {
      "small": "https://images.pokemontcg.io/base1/1.png",
      "large": "https://images.pokemontcg.io/base1/1_hires.png"
    },
    "set": {
      "id": "base1",
      "name": "Base",
      "series": "Base",
      "printedTotal": 102,
      "total": 102,
      "releaseDate": "1999/01/09"
    },
    "cardmarket": {
      "prices": {
        "averageSellPrice": 149.99,
        "lowPrice": 99.99,
        "trendPrice": 199.99
      }
    }
  },
  {
    "id": "base1-15",
    "name": "Venusaur",
    "number": "15",
    "images": {
      "small": "https://images.pokemontcg.io/base1/15.png",
      "large": "https://images.pokemontcg.io/base1/15_hires.png"
    },
    "set": {
      "id": "base1",
      "name": "Base",
      "series": "Base",
      "printedTotal": 102,
      "total": 102,
      "releaseDate": "1999/01/09"
    },
    "cardmarket": {
      "prices": {
        "averageSellPrice": 129.99,
        "lowPrice": 89.99,
        "trendPrice": 169.99
      }
    }
  },
  {
    "id": "base1-12",
    "name": "Ninetales",
    "number": "12",
    "images": {
      "small": "https://images.pokemontcg.io/base1/12.png",
      "large": "https://images.pokemontcg.io/base1/12_hires.png"
    },
    "set": {
      "id": "base1",
      "name": "Base",
      "series": "Base",
      "printedTotal": 102,
      "total": 102,
      "releaseDate": "1999/01/09"
    },
    "cardmarket": {
      "prices": {
        "averageSellPrice": 119.99,
        "lowPrice": 79.99,
        "trendPrice": 159.99
      }
    }
  },
  {
    "id": "base1-8",
    "name": "Gyarados",
    "number": "8",
    "images": {
      "small": "https://images.pokemontcg.io/base1/8.png",
      "large": "https://images.pokemontcg.io/base1/8_hires.png"
    },
    "set": {
      "id": "base1",
      "name": "Base",
      "series": "Base",
      "printedTotal": 102,
      "total": 102,
      "releaseDate": "1999/01/09"
    },
    "cardmarket": {
      "prices": {
        "averageSellPrice": 109.99,
        "lowPrice": 69.99,
        "trendPrice": 149.99
      }
    }
  },
  {
    "id": "base1-11",
    "name": "Nidoking",
    "number": "11",
    "images": {
      "small": "https://images.pokemontcg.io/base1/11.png",
      "large": "https://images.pokemontcg.io/base1/11_hires.png"
    },
    "set": {
      "id": "base1",
      "name": "Base",
      "series": "Base",
      "printedTotal": 102,
      "total": 102,
      "releaseDate": "1999/01/09"
    },
    "cardmarket": {
      "prices": {
        "averageSellPrice": 99.99,
        "lowPrice": 59.99,
        "trendPrice": 139.99
      }
    }
  },
  {
    "id": "base1-13",
    "name": "Poliwrath",
    "number": "13",
    "images": {
      "small": "https://images.pokemontcg.io/base1/13.png",
      "large": "https://images.pokemontcg.io/base1/13_hires.png"
    },
    "set": {
      "id": "base1",
      "name": "Base",
      "series": "Base",
      "printedTotal": 102,
      "total": 102,
      "releaseDate": "1999/01/09"
    },
    "cardmarket": {
      "prices": {
        "averageSellPrice": 89.99,
        "lowPrice": 49.99,
        "trendPrice": 129.99
      }
    }
  },
  {
    "id": "base1-14",
    "name": "Raichu",
    "number": "14",
    "images": {
      "small": "https://images.pokemontcg.io/base1/14.png",
      "large": "https://images.pokemontcg.io/base1/14_hires.png"
    },
    "set": {
      "id": "base1",
      "name": "Base",
      "series": "Base",
      "printedTotal": 102,
      "total": 102,
      "releaseDate": "1999/01/09"
    },
    "cardmarket": {
      "prices": {
        "averageSellPrice": 79.99,
        "lowPrice": 39.99,
        "trendPrice": 119.99
      }
    }
  },
  {
    "id": "base1-16",
    "name": "Zapdos",
    "number": "16",
    "images": {
      "small": "https://images.pokemontcg.io/base1/16.png",
      "large": "https://images.pokemontcg.io/base1/16_hires.png"
    },
    "set": {
      "id": "base1",
      "name": "Base",
      "series": "Base",
      "printedTotal": 102,
      "total": 102,
      "releaseDate": "1999/01/09"
    },
    "cardmarket": {
      "prices": {
        "averageSellPrice": 69.99,
        "lowPrice": 29.99,
        "trendPrice": 109.99
      }
    }
  }
];